module.exports = __webpack_public_path__ + "static/media/image1.8a5c2d6d.png";